import { QueryClient } from '@tanstack/react-query';

/**
 * The app-wide TanStack Query client. Lives in its own module (rather
 * than main.tsx) so non-React code — e.g. the FCM foreground `onMessage`
 * handler — can invalidate queries when a push arrives while a tab is
 * open.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      // ON. A PWA is not a page you close — a citizen leaves it in the
      // background for hours and comes back to whatever was fetched
      // last, which is how City News ends up showing a story the city
      // replaced this morning. `staleTime` still holds: coming back
      // within 30 s of the last fetch costs nothing, and anything older
      // is refreshed the moment the app is looked at again.
      refetchOnWindowFocus: true,
    },
  },
});
